export interface AddressState {
  value: string | undefined;
  label: string;
}

export const AddressState: Array<AddressState> = [
  {
    value: undefined,
    label: "Select state",
  },
  {
    value: "NSW",
    label: "New South Wales",
  },
  {
    value: "VIC",
    label: "Victoria",
  },
  {
    value: "QLD",
    label: "Queensland",
  },
  {
    value: "WA",
    label: "Western Australia",
  },
  {
    value: "SA",
    label: "South Australia",
  },
  {
    value: "TAS",
    label: "Tasmania",
  },
];
